import {Calendar as CalGrid, Appointment} from "../calendar.js";
import {DateRange} from "../date-range.js";
import {ClassGrouper} from "../class-grouper.js";
import {CalendarClassSelector} from "../cal-class-selector.js";
import {CalendarAppTypeSelector} from "../cal-app-type-selector.js";
import {ModalShowAppointment} from "../modals/modalShowAppointment.js";
import {ModalEditAppointment} from "../modals/modalEditAppointment.js";
import "../jSelect.js";
import "../toggle-panel.js";

export class Calendar {

   constructor(app) {

      this.app = app;
      this.dm = app.dm;
      //this.settings = app.settings;
      this.tab = document.querySelector('.main-item[tab-name="calendar"]');

      this.statusbar = this.tab.querySelector('.statusbar');

      this.yearSelect = this.statusbar.jSelect('.select-year');
      this.yearSelect.select.addEventListener('change', (event) => {
         this.loadYear(event.currentTarget.value);
      });

      this.statusbar.querySelector('.filters').togglePanel({
         toggleButton: this.statusbar.querySelector('.open-filters'),
         onClosing: async () => {
            this.saveFilters();
            this.cal.render(true);
         }
      });

      this.content = this.tab.querySelector('.main-content');
      this.content.empty();

      let calSettings = this.dm.getCalendarSettings();

      this.cal = new CalGrid(this.content, {
         accordion: true,
         autoAppend: true,
         dayWidth: calSettings.dayWidth,
         dayHeight: calSettings.dayHeight
      });

      this.classSelector = new CalendarClassSelector({}, this.dm);
      this.appTypeSelector= new CalendarAppTypeSelector();

      let otherFilters = this.statusbar.querySelector('.filters .other');
      otherFilters.append(this.appTypeSelector.getHtmlElement());

      this.onlyMyFilter = otherFilters.createElement('div', "only-my");
      let title = this.onlyMyFilter.createElement('div', 'title');
      title.innerHTML = "Nur von mir erstellte";
      this.onlyMyFilter.addEventListener('click', (event) => {
         this.onlyMyFilter.classList.toggle('selected');
      });

   }

   saveFilters() {
      let filters = this.dm.getCalFilters();

      filters.setClassFilters(this.yearSelect.select.value, this.classSelector.getSelected());
      filters.appTypes = this.appTypeSelector.getSelected(),
      filters.onlyMy = this.onlyMyFilter.classList.contains('selected');
      this.dm.saveCalFilters(filters);
   }

   async loadFilters(year) {

      let filters = this.dm.getCalFilters();
      this.classSelector.setClasses(year.classes, filters.getClassFilters(year.id));
      this.appTypeSelector.setAppTypes(await this.dm.getAppointmentTypes(), filters.appTypes);

      let classFilters = this.statusbar.querySelector('.filters .classes');
      classFilters.empty();
      classFilters.append(this.classSelector.getHtmlElement());

      if (filters.onlyMy === true) this.onlyMyFilter.classList.add('selected');

   }

   async load(loadData, selectYear) {

      let select = (item) => {
         if (selectYear === undefined) return item.isCurrent || undefined;
         else return item.id === selectYear || undefined;
      };

      if (loadData) {
         let years = await this.dm.getYearList();
         if (years.length > 0) {
            let options = years.map(item => { return {
               title: item.name,
               value: item.id,
               selected: select(item)
            }; })
            this.yearSelect.setOptions(options);
            await this.loadYear(this.yearSelect.select.value);
         }
      }
      else {
         this.cal.render();
      }



      /*
      logger.message('loaded');
      const compStyle = window.getComputedStyle(this.tab.querySelector('.month-title'));
      logger.message(compStyle.width);
      logger.message(this.tab.querySelector('.month-title').classList.value);
      */


      this.onlyMyFilter.style.display = this.dm.getUserSelf().type === 'teacher' ? 'block' : 'none';

      let lastChange = localStorage.getItem('lastUpdateAppointments');
      //this.tab.querySelector('.statusbar .lastUpdate .time').innerHTML = lastUpdate ? lastUpdate.format("%d.%m.%Y %H:%i:%s Uhr") : '-';
      this.tab.querySelector('.statusbar .lastUpdate .time').innerHTML = lastChange ? new Date(parseInt(lastChange)*1000).format("%d.%m.%Y %H:%i Uhr") : '-';
      this.tab.setAttribute('loaded', '');

   }



   async loadYear(yearId) {

      this.cal.clear();
      yearId = parseInt(yearId);

      let appTypes = await this.dm.getAppointmentTypes();
      let year     = await this.dm.getYear(yearId);
      let classGrouper = new ClassGrouper(Object.values(year.classes));
      let calSettings = this.dm.getCalendarSettings();

      this.cal.setDaySize(calSettings.dayWidth, calSettings.dayHeight);
      this.cal.setColumns(calSettings.dayColumns === 0 ? "auto" : calSettings.dayColumns);

      await this.loadFilters(year);

      // Callbacks definieren
      this.cal.renderAppointment = (container, app) => {

         container.dataset.appId = app.id;
         container.dataset.appTypeId = app.typeId;
         //console.log(app.classes);
         let classes = app.classes.length == 0 ? '': '<span class="classes">' + classGrouper.group(app.classes).join(',') + '</span>';

         if (app.typeId in appTypes) {
            let type = appTypes[app.typeId];
            container.setStyles(type.css);
            container.style.backgroundColor = type.color;
         }
         container.innerHTML = `${classes}<span class="title">${app.title}</span>`;
         container.style.fontSize = calSettings.fontSize / 100 + 'rem';
      };
      //this.cal.setColumns(7);
      let appointments = {};
      this.cal.setDateRange(Date.fromString(year.dateFrom), Date.fromString(year.dateTo));

      let dm = this.dm;

      this.cal.onGetAppointments = async (sectionRange) => {

         let appData = await dm.getAppointmentsInRange(yearId, sectionRange);
         let selectedClasses = this.classSelector.getSelected();
         let selectedAppTypes = this.appTypeSelector.getSelected();
         let onlyMy = this.onlyMyFilter.classList.contains('selected');
         let user = this.dm.getUserSelf();

         appData = appData.filter(item => {
            if (!selectedAppTypes.includes(item.typeId)) return false;
            if (onlyMy && item.creator !== user.id && item.owners[user.id] === undefined) return false;
            return item.classes.length === 0 || selectedClasses.some((cl) => { return cl in item.classes; });
         });

         let apps = [];
         for (let app of appData) {
            let appRange = new DateRange(Date.fromString(app.dateFrom), Date.fromString(app.dateTo));
            if (appRange.hasIntersection(sectionRange)) {
               appointments[app.id] = app;
               apps.push(new Appointment(app.dateFrom, app.dateTo, app));
            }
         }

         apps.sort((a,b) => {
            if (a.isoDateFrom < b.isoDateFrom) return -1; // erstes Sortierkriterium: Anfangsdatum
            if (a.isoDateFrom > b.isoDateFrom) return 1;
            if (a.isoDateFrom === a.isoDateTo && b.isoDateFrom !== b.isoDateTo) return 1; // Langzeittermine vor Ein-Tages-Terminen anzeigen
            if (a.isoDateFrom !== a.isoDateTo && b.isoDateFrom === b.isoDateTo) return -1;
            if (appTypes[a.data.typeId].sort < appTypes[b.data.typeId].sort) return -1 // Nach Termintyp sortieren
            if (appTypes[a.data.typeId].sort > appTypes[b.data.typeId].sort) return 1
            return 0;
         });

         return apps;

      };

      this.cal.onSectionRendered = (grid) => {

         grid.querySelectorAll('.appointment').addEventListener('click', (event) => {
            let app = appointments[event.currentTarget.dataset.appId];
            new ModalShowAppointment(this.app, app, classGrouper.group(app.classes).join(','), dm);
         });

         if (this.dm.getUserSelf().type !== 'teacher') return;

         grid.querySelectorAll('.calendar-day, .day-label').addEventListener('click', (event) => {
            const date = event.currentTarget.dataset.date;
            new ModalEditAppointment(app, { dateFrom: date, dateTo: date });
         });
      };

      await this.cal.renderSections(new Date().isoDate());

   }


}
